<template>
    <customModal :containermd="true" :bodysm="true" @closeModal="closeSdvModal">
        <template #title>
            {{ $t("navigations.assign sdv") }}
        </template>
        <template #body>
           <div class="row">
            <!-- Row 1: SDV Level -->
            <div class="col-lg-12 mb-2">
              <label class="col-form-label me-1 py-0">{{ $t("navigations.sdv level") }} : </label>
              <div class="form-control-plaintext py-0">
                <strong>{{ sdvInfo.sdvLevel || '-' }}</strong>
              </div>
            </div>

            <!-- Row 2: Fields -->
            <div class="col-lg-12 mb-2 d-flex align-items-center">
              <label class="col-form-label py-0 me-1">{{ $t("navigations.fields") }} : </label>
              <div>
                <template v-if="(sdvInfo.fields || []).length">
                  <span v-for="(f, idx) in sdvInfo.fields" :key="idx" class="badge badge-genre me-1">{{ f }}</span>
                </template>
                <span v-else class="text-muted">{{ $t('navigations.no fields') }}</span>
              </div>
            </div>

            <!-- Row 3: Role & User selectors -->
            <div class="col-lg-6">
              <label class="col-form-label">{{ $t("navigations.role") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
              <select v-model="selectedRole" class="form-control" @change="roleChanged()">
                <option disabled value="">{{ $t("navigations.please select role") }}</option>
                <option v-for="role in roleList" :key="role.roleID" :value="role.roleID">{{ role.roleName }}</option>
              </select>
            </div>
            <div class="col-lg-6">
              <label class="col-form-label">{{ $t("navigations.user") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
              <select v-model="values.Recipient" class="form-control">
                <option disabled value="">{{ $t("navigations.please select user") }}</option>
                <option v-for="recipient in recipients" :key="recipient.email" :value="recipient.email">{{ recipient.email }}</option>
              </select>
            </div>

            <div class="col-12 d-flex justify-content-center my-3">
              <button @click.prevent="assignSdv()" class="save_btn py-1 px-4 position-relative">
                <div class="toc-loader position-absolute" :class="{ 'opacity-0': !loadingBlock, 'opacity-1': loadingBlock }">
                  <img src="../../assets/img/loading.gif" width="15" class="loading-btn-img" alt="Waiting for login" />
                </div>
                <div :class="{ 'opacity-1': !loadingBlock, 'opacity-0': loadingBlock }">{{ $t("navigations.assign") }}</div>
              </button>
            </div>

           </div>
        </template>
        
    </customModal>
   
        
</template>
<script src="./AssignFormSdvModal.js"></script>
<style scoped>
.errormsg {
  min-height: 20px;
  display: block;
}
.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 100001 !important;
}

.modal__schedule__container {
  background: #fff;
  width: min(60%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(40%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}
</style>
